import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { Actions, AppArea, LoginRuleListFilterInput, Subjects } from 'src/graphql/generated/graphql';
import { useLoginRules } from 'src/hooks/query/use-login-rules';
import { useTable } from 'src/hooks/use-table';
import { LoginRulesTable } from './table';
import { Filter } from './filter';
import { Routes } from 'src/components/common/router/constants';
import { Link } from 'src/components/common/link';
import { Button } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Can } from 'src/utils/can';

const PAGINATION_LIMIT = 10;

export const LoginRuleList = () => {
  const { t } = useTranslation();

  const { page, setPage, filter, onFilterChange, defaultFilter } = useTable<
    LoginRuleListFilterInput,
    Record<any, any>
  >();

  const { loading, data, totalCount } = useLoginRules({
    filter,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
  });

  return (
    <Can I={Actions.Read} a={Subjects.LoginRules} appArea={AppArea.Admin}>
      <FilterWrapper>
        <Filter onSubmit={onFilterChange} defaultFilter={defaultFilter} />
      </FilterWrapper>

      <ContentWrapper>
        <TableWrapper>
          <Can I={Actions.Write} a={Subjects.LoginRules} appArea={AppArea.Admin}>
            <div className="flex justify-end">
              <Link to={Routes.loginRuleCreate.path}>
                <Button variant="contained">
                  {t('login-rules.list.create-button')}
                </Button>
              </Link>
            </div>
          </Can>
          <LoginRulesTable
            data={data}
            className="mt-4"
            loading={loading}
            options={{
              page,
              count: totalCount,
              sort: true,
              rowsPerPage: PAGINATION_LIMIT,
              onChangePage: setPage,
              enableNestedDataAccess: '.',
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </Can>
  );
};
